import Vue from 'vue'
window.Vue = Vue
import axios from './setup/axios'

class VueLodash {
  constructor() { }
  static install(Vue) {
    Vue._ = _
    Object.defineProperty(Vue.prototype, '$_', {
      get: function get() {
        return _
      },
    })
  }
}
Vue.use(VueLodash)

if (document.querySelector('#app') !== null) {
  const files = require.context('./', true, /\.vue$/i)
  files.keys().map(key => {
    Vue.component(
      key
        .split('/')
        .pop()
        .split('.')[0],
      files(key).default
    )
  })
  /* global VueLangTrans */
  Vue.use(VueLangTrans)
  //Vue.use(VueRoutes)

  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: '#app',
    axios,
  })
}
